import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageTitles = {
  '/': 'Beranda',
  '/jadwal-hasil': 'Jadwal & Hasil',
  '/klasemen': 'Klasemen',
  '/top-skor': 'Top Skor',
  '/statistik': 'Statistik',
  '/peserta': 'Tim Peserta',
  '/berita': 'Berita',
  '/galeri': 'Galeri',
  '/tentang-kami': 'Tentang Kami',
  '/admin': 'Admin Panel',
  '/admin/login': 'Login Admin',
  '/admin/dashboard': 'Dashboard',
  '/admin/banners': 'Kelola Banner',
  '/admin/advertisements': 'Kelola Iklan',
  '/admin/news': 'Kelola Berita',
  '/admin/photos': 'Kelola Foto',
  '/admin/videos': 'Kelola Video',
  '/admin/matches': 'Kelola Pertandingan',
  '/admin/standings': 'Kelola Klasemen',
  '/admin/top-scorers': 'Kelola Top Skor',
  '/admin/club-admins': 'Kelola Admin Klub',
  '/admin/audit-logs': 'Audit Log',
  '/admin/participants': 'Kelola Peserta',
  '/admin/hubungi-kami': 'Hubungi Kami',
  '/admin/settings': 'Pengaturan',
};

export function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = pageTitles[path];
    
    // Handle dynamic routes
    if (!title) {
      if (path.startsWith('/berita/')) {
        title = 'Detail Berita';
      } else if (path.startsWith('/admin/')) {
        title = 'Admin Panel';
      } else {
        title = 'Halaman';
      }
    }
    
    document.title = `IJSL - ${title}`;
  }, [location]);
}

export default usePageTitle;
